import { useEffect, useState } from "react";
import { Alert, Box, Chip, CircularProgress, Stack, Typography } from "@mui/material";
import PageTopBar from "../../../components/common/PageTopBar";
import { FacultyWeekGrid, WeekSummary } from "../components/timetable/FacultyWeekGrid";
import { fetchMyTimetable } from "../services/timetableService";
import { FacultyTimetable } from "../types";

/** My Timetable: the logged-in faculty's week, read-only (GET /timetable/me). */
export default function MyTimetablePage() {
  const [timetable, setTimetable] = useState<FacultyTimetable | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    fetchMyTimetable()
      .then(setTimetable)
      .catch(() => setError("Failed to load your timetable."))
      .finally(() => setLoading(false));
  }, []);

  const title = (
    <Stack direction="row" spacing={1} alignItems="center">
      <Typography variant="h6" fontWeight={600}>
        My Timetable
      </Typography>
      {timetable?.academicYear && <Chip label={timetable.academicYear} size="small" variant="outlined" color="primary" sx={{ fontWeight: 600 }} />}
    </Stack>
  );

  return (
    <Box sx={{ mt: 2, mr: 2 }}>
      <PageTopBar left={title} right={timetable && <WeekSummary timetable={timetable} />} />
      {loading ? (
        <Box display="flex" justifyContent="center" py={8}>
          <CircularProgress size={28} />
        </Box>
      ) : error ? (
        <Alert severity="error">{error}</Alert>
      ) : (
        timetable && <FacultyWeekGrid timetable={timetable} />
      )}
    </Box>
  );
}
